module.exports = __webpack_public_path__ + "img/view-tree-animation-1.9aade882.png";